export interface IResponsibleCenter {
    id: number,
    alias: string
}